import React from 'react';
import EqpMonitorMngContainer from '../../containers/eqpmng/EqpMonitorMngContainer';

const EqpMonitorMngPage = () => {
  return <EqpMonitorMngContainer />;
};

export default EqpMonitorMngPage;
